import { render, staticRenderFns } from "./BaseDetailItem.vue?vue&type=template&id=0eca9aa1&scoped=true"
import script from "./BaseDetailItem.vue?vue&type=script&lang=js"
export * from "./BaseDetailItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eca9aa1",
  null
  
)

/* custom blocks */
import block0 from "./BaseDetailItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports